const GA_MEASUREMENT_ID = 'G-VY0QYD8J91';

const buildAnalyticsContext = () => {
  if (typeof window === 'undefined') {
    return {};
  }

  return {
    page_path: window.location.pathname,
    page_location: window.location.href,
  };
};

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  const sanitizedParams = Object.entries({
    ...buildAnalyticsContext(),
    ...params,
  }).reduce((accumulator, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      accumulator[key] = value;
    }

    return accumulator;
  }, {});

  window.gtag('event', eventName, sanitizedParams);
};

/** SPA page views — initial load is covered by gtag('config'); this covers route changes. */
export const trackPageView = (path, title) => {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') {
    return;
  }

  const pagePath = path || window.location.pathname + window.location.search;
  window.gtag('event', 'page_view', {
    page_path: pagePath,
    page_location: window.location.origin + pagePath,
    page_title: title || document.title,
    send_to: GA_MEASUREMENT_ID,
  });
};

/** Fired when a user submits a flight search (form, deal, or SEO landing). */
export const trackFlightSearch = (params = {}) => {
  trackEvent('flight_search', params);
};
